import { useChartSeries } from '@/features/charts';
import FullScreenChart from '@/features/markets/components/Chart/FullScreenChart';
import { useLightMode } from '@/shared/lib/LightModeContext';
import type { TemplateChartSeries } from '@/shared/types/charts';

export const FullScreenChartContent = ({
  templateChartSeries,
  tabName,
  activeTab
}: {
  activeTab: number;
  templateChartSeries?: TemplateChartSeries[];
  tabName: string;
}) => {
  const { loading, error, chartSeries } = useChartSeries(templateChartSeries, false);
  const { isLightMode } = useLightMode();

  return (
    <FullScreenChart
      key={activeTab}
      chartSeries={chartSeries}
      error={error}
      isLightMode={isLightMode}
      loading={loading}
      tabName={tabName}
    />
  );
};
